"use client";
import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
import { useMovementDetection } from "@/components/useMouseMovement";
const PaymentMain = dynamic(() => import("@/components/payment/payment-main"), { ssr: false });
export type CartDisplayType = "cart" | "checkout" | "payment";

interface Props {
    displayType?: CartDisplayType;
    radiusStyle: any;
}

const PaymentMainLoader = ({ displayType, radiusStyle }: Props) => {
    const [showComponent, setShowComponent] = useState(false);
    const hasInteracted = useMovementDetection();
    useEffect(() => {
        if (hasInteracted) {
            setShowComponent(true);
        }
    }, [hasInteracted]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowComponent(true);
        }, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return showComponent ? <PaymentMain radiusStyle={radiusStyle}/> : null;
};

export default PaymentMainLoader;
